// extracted by mini-css-extract-plugin
export default {"actualites":"Actualites_actualites__5MWnO","fadeInUp":"Actualites_fadeInUp__tlvdB","blockActualites":"Actualites_blockActualites__W5yUM"};